import { TFunction } from "i18next";

const GATEWAY_SLUG_ALIASES: Record<string, string> = {
  mercadopago: "mercado_pago",
  "mercado-pago": "mercado_pago",
  mp: "mercado_pago",
};

export const resolvePaymentGatewayLabelKey = (gatewaySlug: string): string => {
  const normalized = gatewaySlug.trim().toLowerCase().replace(/-/g, "_");
  const aliased = GATEWAY_SLUG_ALIASES[normalized] ?? GATEWAY_SLUG_ALIASES[gatewaySlug] ?? normalized;

  return `studio.orders.payment.gateway.${aliased}`;
};

export const resolvePaymentGatewayLabel = (
  gatewaySlug: string | null | undefined,
  t: TFunction,
  emptyLabel = "—"
): string => {
  if (!gatewaySlug) {
    return emptyLabel;
  }

  const key = resolvePaymentGatewayLabelKey(gatewaySlug);
  const translated = t(key, { defaultValue: gatewaySlug });

  return translated === key ? gatewaySlug : translated;
};
